/**
 * バージョン情報ページ内容
 */

import { TableRow } from "../components/TableRow";

/**
 *
 * @returns バージョン情報ページの JSX Element
 */
export const Version: React.FC = () => {
  return (
    <div>
      <section className="c-section">
        <h2 className="p-heading-2">バージョン情報</h2>
        <table className="c-table">
          <tbody>
            <TableRow label="公開日" value="2015.02.03" />
            <TableRow label="ドライバーソフトウェア" value="Ver 1.02" />
            <TableRow label="CMCD_UPLOAD" value="Ver 1.0.0.0" />
          </tbody>
        </table>
      </section>
    </div>
  );
};
